export const SharePointLinkType = {
    view: "view", //Creates a read-only link to the item.
    review: "review", //Creates a review link to the item. This option is only available for files in OneDrive for Business and SharePoint.
    edit: "edit", //Creates an read-write link to the item.
    embed:	"embed", //Creates an embeddable link to the item.
    blocksDownload:	"blocksDownload", //Creates a read-only link that blocks download to the item. This option is only available for files in OneDrive for Business and SharePoint.
    createOnly:	"createOnly", //Creates an upload-only link to the item. This option is only available for folders in OneDrive for Business and SharePoint.
    addressBar:	"addressBar", //Creates the default link that is shown in the browser address bars for newly created files. Only available in OneDrive for Business and SharePoint. The organization admin configures whether this link type is supported, and what features are supported by this link type.
    adminDefault: "adminDefault", //Creates the default link to the item as determined by the administrator of the organization. Only available in OneDrive for Business and SharePoint. The policy is enforced for the organization by the admin
}

export const SharePointPermissionRole = {
    none: "none", 
    read: "read", 
    write: "write", 
    owner: "owner"
}

export const SharePointScope = {
    
    anonymous: "anonymous", //Anyone with the link has access, without needing to sign in. This may include people outside of your organization. Anonymous link support may be disabled by an administrator.
    organization: "organization", //Anyone signed into your organization (tenant) can use the link to get access. Only available in OneDrive for Business and SharePoint.
    users: "users", //Specific people in the recipients collection can use the link to get access. Only available in OneDrive for Business and SharePoint.
}


export const SharePointScopeOptions = [
    {id: "users", text: "Chỉ định đối tượng" },
    {id: "organization", text: "Công ty" },
    {id: "anonymous", text: "Tất cả đối tượng trong công ty và bên ngoài" },
    
]   

export const SharePointLinkTypeOptions = [
    {id: "view", text: "Xem" },
    {id: "review", text: "Lấy ý kiến" },
    {id: "edit", text: "Chỉnh sửa" },
    {id: "blocksDownload", text: "Xem nhưng không cho tải" },
    
]